<template>

    <article class="figure-pop"> 
        <figure>
            <div class="new-tag" v-if="diferenciaFecha(pop)">Recién llegado</div>
            <div class="promotion-tag" v-if="pop.descuentoPrecioPublico > 0">
                Figura con descuento
            </div>
            <img :src="pop.imagenUrl" width="232" height="232" />
        </figure>
        
        <div class="product-details">
            <h3>{{pop.licencia}} - {{pop.nombre}}</h3>
            <span v-bind:class="['price',pop.descuentoPrecioPublico > 0 ? 'withDiscount': '']">
                ${{pop.precioPublico}}
            </span>
            <div v-if="pop.descuentoPrecioPublico > 0" class="price">
                ${{pop.precioPublico - pop.descuentoPrecioPublico}} 
            </div>
            <div v-if="existencia">
                Cantidad disponible: {{validacionDisponibilidad(pop)[0]}}
            </div>
            <div v-if="validacionDisponibilidad(pop)[0] === 1" class="last-figure"> 
                !!! Última pieza !!!
            </div>
        </div>
        <div class="type-pop">{{pop.tipoPop}}</div>
    </article>
</template>

<script>

import moment from 'moment';

export default{
    props: {
        'pop': {
            type: Object
        },
        'existencia' : {
            type: Boolean
        }
    },
    methods: {
        diferenciaFecha(pop){
            //console.log(pop);
            const fechaLlegada = pop.fechaLlegada;
            //console.log(fechaLlegada);
            var end = moment(moment.utc()); 
            var days = end.diff(fechaLlegada, "days", true); 
            if(days <= 0 || days >= 8){
                return false
            }
            else if(days <= 7){
                return true
            }
              //console.log(days)
        },
        validacionDisponibilidad(pop){
            let totalApartados = null;
            if (pop.apartados) {
                totalApartados = Object.keys(pop.apartados).reduce(
                (suma, indice) => suma + pop.apartados[indice].cantidadApartada,
                0
                );
            }
            return [
                pop.cantidadDisponible - totalApartados ?? 0,
                totalApartados ?? 0,
            ];
        },
    }
    
}

</script>

<style lang="scss" scoped>

    @function pxToRem($value) {
        $remValue: ($value / 16) + rem; 
        @return $remValue;
    }

    .figure-pop{
        position: relative;
        background: #fff;
        //transition: all .2s ease;
        box-shadow: 1px 4px 4px -1px rgba(0, 0, 0 , 0.15);
        height: 100%;
        border-radius: 0.5rem;
        padding-bottom: pxToRem(28);
        display: flex;
        flex-direction: column;
        align-items: center;
        @media (min-width: 767px){
            padding-bottom: pxToRem(34);
        }
        figure{
            position:relative;
        }
        img{
            max-width: 100%;
            height: auto;
        }
        .last-figure{
            color: #D0342C;
            font-size: pxToRem(12);
            @media (min-width: 767px){
                font-size: pxToRem(14);
            }
        }
        .promotion-tag{
            background-color: #FF4500;
            color: white;
            font-weight: bold;
            padding: 0.3125rem 0.75rem;
            position: absolute;
            top: 0;
            border-top-left-radius: 0.5rem;
            font-size: pxToRem(12);
            line-height: 1;
            @media (min-width: 767px){
                padding: 0.3125rem 1.25rem;
            }
        }
        .new-tag{
            background-color: #63b4c1;
            color: white;
            font-weight: bold;
            padding: 0.3125rem 0.75rem;
            position: absolute;
            bottom: 0px;
            right: 0;
            //border-bottom-right-radius: 0.5rem;
            font-size: pxToRem(12);
            line-height: 1;
            @media (min-width: 767px){
                padding: 0.3125rem 1.25rem;
            }
        }
        .product-details{
            padding: pxToRem(10);
            display: flex;
            flex-direction: column;
            flex: 1 0 auto;
            @media (min-width: 767px){
                padding: pxToRem(20);
            }
            h3{
                text-transform: uppercase;
                font-weight: bold;
                font-size: pxToRem(12);
                margin: 0 0 pxToRem(5);
                flex: 1 1 0%;
                @media (min-width: 767px){
                    font-size: pxToRem(18);
                }
            }
            .price{
                //flex: 1 0 auto;
                font-size: pxToRem(14);
                position: relative;
                width: fit-content;
                @media (min-width: 767px){
                    font-size: pxToRem(16);
                }
                &.withDiscount{
                    color: #999;
                    font-size: pxToRem(12);
                    &:after{
                        border-top: 1px solid;
                        position: absolute;
                        content: "";
                        right: 0;
                        top: 50%;
                        left: 0;
                    }
                }
            }
        }
        .type-pop{
            background-color: #42b883;
            color: #fff;
            font-weight: bold;
            padding: pxToRem(5) pxToRem(20);
            position: absolute;
            bottom: 0;
            width: 100%;
            border-bottom-left-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
            font-size: pxToRem(12);
            @media (min-width: 767px){
                font-size: pxToRem(16);
            }
        }
    }


</style>